import PropTypes from "prop-types";
import ListingContent from "app/pages/Listing/ListingContent/ListingContent";
import { connect } from "react-redux";
import { getListingItems, isAnyListingFilterActive } from "app/pages/Listing/productsSelector";
import { LISTING_ITEM_TYPES } from "app/constants";
import PropsTypes from "prop-types";

const ListingContentContainer = ({ ...props }) => {
	return <ListingContent {...props} />;
};

ListingContentContainer.propTypes = {
	spotlightUri: PropTypes.string,
};

const mapStateToProps = (state, props) => {
	const orderedListingItems = getListingItems(props.spotlightUri)(state);
	const merchsListingItems = orderedListingItems.filter(item =>
		[LISTING_ITEM_TYPES.MERCH_SIMPLE, LISTING_ITEM_TYPES.MERCH_CAROUSSEL].includes(item.type)
	);
	return {
		isAnyListingFilterActive: isAnyListingFilterActive(state),
		merchsListingItems: merchsListingItems,
		resolution: state.resolution,
		activeProductsFilters: state.productsFilters,
	};
};

ListingContentContainer.propTypes = {
	spotlightUri: PropsTypes.string,
	merchsListingItems: PropsTypes.array,
	resolution: PropsTypes.string,
	activeProductsFilters: PropsTypes.object,
	isAnyListingFilterActive: PropsTypes.bool,
};

export default connect(mapStateToProps)(ListingContentContainer);
